import { motion } from 'framer-motion';

const EmpresaLoader = ({
  logoUrl,
  nombre,
  onLogoLoad,
  onLogoError,
}: {
  logoUrl?: string | null;
  nombre?: string | null;
  onLogoLoad?: () => void;
  onLogoError?: () => void;
}) => (
  <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 px-6 overflow-hidden">
    <div
      className="absolute inset-0 dark:hidden"
      style={{
        background:
          'linear-gradient(170deg, #103254 0%, #103254 25%, #1a4a6e 45%, #3d7fa0 68%, #a8cfe0 84%, #e8f4f8 95%, #ffffff 100%)',
      }}
    />
    <div
      className="absolute inset-0 hidden dark:block"
      style={{
        background:
          'linear-gradient(170deg, #050807 0%, #0a1a16 22%, #123a30 42%, #103254 60%, #0a0f14 82%, #000000 100%)',
      }}
    />

    {logoUrl && (
      <motion.img
        src={logoUrl}
        alt={nombre ?? 'Logo'}
        onLoad={onLogoLoad}
        onError={onLogoError}
        className="relative z-10 w-36 h-36 sm:w-44 sm:h-44 rounded-full object-cover border-2 border-white/80 shadow-xl bg-white"
        initial={{ scale: 0.85, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      />
    )}
  </div>
);

export default EmpresaLoader;
